import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "fillColor", "fillMainColor", "fillGray", "fillLightGray", "fillCautionColor", "fillTransparentGray", "fillWhiteColor", "borderBlue", "borderGray", "borderLight", "borderCaution", "fontFixed", "fontBold", "large", "medium", "small", "largeFont", "favBtn", "favBtnWithLabel", "listRow", "scale", "inline", "transparent", "loading", "hoverAnimation", "bgColor", "withIcon", "disabledWithGray", "borderStyle", "borderFillColor", "chatSend", "chatCloseX", "chatSelect", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import buttonStyles from "@/styles/Button.module.scss";
import classnames from "classnames";
import { forwardRef, useCallback, useEffect, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className,
      fillColor,
      fillMainColor,
      fillGray,
      fillLightGray,
      fillCautionColor,
      fillTransparentGray,
      fillWhiteColor,
      borderBlue,
      borderGray,
      borderLight,
      borderCaution,
      fontFixed,
      fontBold,
      large,
      medium,
      small,
      largeFont,
      favBtn,
      favBtnWithLabel,
      listRow,
      scale,
      inline,
      transparent,
      loading,
      hoverAnimation,
      bgColor,
      withIcon,
      disabledWithGray,
      borderStyle,
      borderFillColor,
      chatSend,
      chatCloseX,
      chatSelect,
      onClick
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const processing = useRef(false);
  const timeoutId = useRef();
  const handleClick = useCallback(e => {
    if (processing.current) {
      e === null || e === void 0 || e.preventDefault();
      return;
    } else {
      if (typeof onClick === "function") {
        onClick(e);
      }
      processing.current = true;
      timeoutId.current = setTimeout(() => {
        processing.current = false;
      }, 3000);
    }
  }, [onClick]);
  useEffect(() => {
    return () => {
      processing.current = false;
      clearTimeout(timeoutId.current);
    };
  }, []);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    ref: ref,
    className: classnames(buttonStyles.btn, className, {
      [buttonStyles.fillColor]: fillColor,
      [buttonStyles.borderFillColor]: borderFillColor,
      [buttonStyles.fillMainColor]: fillMainColor,
      [buttonStyles.fillGray]: fillGray,
      [buttonStyles.fillLightGray]: fillLightGray,
      [buttonStyles.fillCautionColor]: fillCautionColor,
      [buttonStyles.fillTransparentGray]: fillTransparentGray,
      [buttonStyles.fillWhiteColor]: fillWhiteColor,
      [buttonStyles.borderBlue]: borderBlue,
      [buttonStyles.borderGray]: borderGray,
      [buttonStyles.borderLight]: borderLight,
      [buttonStyles.borderCaution]: borderCaution,
      [buttonStyles.fontFixed]: fontFixed,
      [buttonStyles.fontBold]: fontBold,
      [buttonStyles.large]: large,
      [buttonStyles.medium]: medium,
      [buttonStyles.small]: small,
      [buttonStyles.largeFont]: largeFont,
      [buttonStyles.favBtn]: favBtn && !favBtnWithLabel,
      [buttonStyles.favBtnWithLabel]: favBtn && favBtnWithLabel,
      [buttonStyles.listRow]: listRow,
      [buttonStyles.scale]: scale,
      [buttonStyles.inline]: inline,
      [buttonStyles.transparent]: transparent,
      [buttonStyles.loading]: loading,
      [buttonStyles.hoverAnimation]: hoverAnimation,
      [buttonStyles.bgColor]: bgColor,
      [buttonStyles.withIcon]: withIcon,
      [buttonStyles.disabledWithGray]: disabledWithGray,
      [buttonStyles.borderStyle]: borderStyle,
      [buttonStyles.chatSend]: chatSend,
      [buttonStyles.chatCloseX]: chatCloseX,
      [buttonStyles.chatSelect]: chatSelect
    }),
    onClick: handleClick
  }, _props), {}, {
    children: props.children
  }));
});
Button.displayName = "Button";
export default Button;